import styled from 'styled-components'

export const FormContainer = styled.div`
	margin-left: 20px;
	display: flex;
	/*justify-content: center;*/
	align-items: center;
	
`

export const SaveIcon = styled.div`
	cursor: pointer;
	display: flex;
	justify-content: center;
	align-items: center;
	margin-right: 8px;
	width: 20px;
	height: 20px;
	border-radius: 50%;
	background: ${({theme}) => theme.primaryColor};
`